import React, { useRef } from "react";
import "../Dashboard/Dashboard.css";
import { Link } from "react-router-dom";
// import { AiOutlineCalendar } from "react-icons/ai";
import { Button, } from "rsuite";
// import 'rsuite/Button/styles/index.css';

import { useTranslation } from 'react-i18next';

import { useState, useEffect, lazy, Suspense, useMemo } from "react";
import axios from "axios";
import { finalRouteApi, adminApiHeader } from "../../components/CommonApis/CommonApiUrl";
import 'chart.js/auto';
import { connect } from "react-redux";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import { FiUpload, FiSettings, FiCheckCircle, FiClock, FiEye, FiExternalLink, FiZap, FiX, FiFolder, FiMail, FiVideo, FiServer, FiShield, FiGlobe, FiPlayCircle, FiDatabase, FiCreditCard, FiUsers, FiChevronDown, FiDownload, FiBookOpen, FiFileText, FiTrendingUp, FiActivity, FiInfo, FiBarChart2, FiList, FiChevronRight, FiRefreshCw } from "react-icons/fi";
import { LuCrown } from "react-icons/lu";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../components/CommonComponents/MessageSubHeading";
import { FiHelpCircle } from "react-icons/fi";
import Dashboard_Partner from "./Dashboard_Partner";
import { useMyContext } from "../../components/Provider/CommonProvider";
// import 'rsuite/Modal/styles/index.css'; // If Modal from rsuite is used


import { FaExclamationTriangle, FaYoutube, FaHdd } from "react-icons/fa";
import TutorialModal from "./TutorialModal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaMagic, FaTv, FaRobot, FaShoppingCart, FaBullhorn, FaCode, FaPaintBrush } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { usePlayoutTour } from "../../components/Tour/PlayoutTourProvider";

const Line = lazy(() => import('react-chartjs-2').then(module => ({ default: module.Line })));
const Bar = lazy(() => import('react-chartjs-2').then(module => ({ default: module.Bar })));
const Pie = lazy(() => import('react-chartjs-2').then(module => ({ default: module.Pie })));
const Chart = lazy(() => import("react-apexcharts"));

const trendChartOptions = {
  chart: { toolbar: { show: false }, zoom: { enabled: false }, fontFamily: 'Inter, sans-serif' },
  stroke: { curve: 'smooth', width: 3 },
  colors: ['#249CFF', '#0A579E'],
  xaxis: {
    categories: ['Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr'],
    axisBorder: { show: false },
    axisTicks: { show: false }
  },
  yaxis: { labels: { formatter: (val) => val.toFixed(1) + ' GB' } },
  tooltip: { y: { formatter: (val) => val.toFixed(2) + ' GB' } },
  grid: { borderColor: '#f1f1f1', strokeDashArray: 4 }
};

function Dashboard({ onlyPermission, adminSetting, userDetails, storage_settings }) {
  const DEPLOYMENT_ID = process.env.REACT_APP_Baseurl_DEPLOYMENT_ID
  const tutorialRef = useRef();
  const openTutorial = () => {
    if (tutorialRef.current) {
      tutorialRef.current.open(); // ✅ opens modal manually
    }
  };
  const { fetchOrganisationDetails, isExpired, isSubscriptionEnded, getExpiryMessage, orgDetails } = useMyContext()
  const { t } = useTranslation();
  const [banner, setBanner] = useState()
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);
  const [daysLeft, setDaysLeft] = useState(null);
  const [themeSettings, setThemeSettings] = useState(null);
  const [cdnUsage, setCdnUsage] = useState({ data: {}, storageLimit: 0 });
  const [storageData, setStorageData] = useState(null);
  const [showSkipModal, setShowSkipModal] = useState(false);
  const [tourSkipped, setTourSkipped] = useState(localStorage.getItem('playout_tour_cta_skipped') === 'true');
  const [isHighlightActive, setIsHighlightActive] = useState(false);
  const [showUsageModal, setShowUsageModal] = useState(false);

  const [bwBreakdownOpen,   setBwBreakdownOpen]   = useState(false);
  const [cdnRefreshing,     setCdnRefreshing]     = useState(false);

  const { startPlayoutTour } = usePlayoutTour();

  const getCookieKey = () => {
    const username = localStorage.getItem("username");
    return username ? `playout_tour_seen_${username.replace(/[^a-zA-Z0-9]/g, '_')}` : 'playout_tour_seen';
  };

  const isPlayoutUser = Number(userDetails?.permission_id) === 5;
  const tourSeen = Cookies.get(getCookieKey()) === 'true';
  const showPlayoutCTA = isPlayoutUser && !tourSeen && !tourSkipped;

  useEffect(() => {
    if (showPlayoutCTA) {
      setIsHighlightActive(true);
    } else {
      setIsHighlightActive(false);
    }
  }, [showPlayoutCTA]);

  const handleExplorePlayout = () => {
    setIsHighlightActive(false);
    window.location.href = "/tv-playouts"; // We use href to ensure the global provider picks up the fresh path and triggers auto-start logic
  };

  const handleSkipPlayoutCTA = () => {
    setIsHighlightActive(false);
    setTourSkipped(true);
    localStorage.setItem('playout_tour_cta_skipped', 'true');
    setShowSkipModal(true);
  };

  const adminPermission = Number(userDetails?.permission_id) === 1 || Number(userDetails?.permission_id) === 2 || Number(userDetails?.permission_id) === 3

  const productoptions = [
    {
      value: "video_library",
      title: "Video Library",
      description:
        "Manage, monetize, and deliver on-demand videos to your audience.",
    },
    {
      value: "playout",
      title: "Playout",
      description:
        "Schedule 24x7 channel-like streaming using your videos.",
    },
    {
      value: "full_package",
      title: "Full Package",
      description:
        "Unlock Video Library, Livestream, and Playout all in one plan.",
    },
  ];

  const baseservices = [
    {
      title: "Pixlnexs",
      desc: "3D animation company delivering high-quality visuals and immersive animated content for brands. Turn ideas into striking 3D experiences.",
      btnText: "Bring Ideas Alive Now!",
      link: "https://store.pixlnexs.com/?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell",
      color: "purple",
      icon: <FaMagic />,
    },
    {
      title: "Wcart",
      desc: "Ecommerce platform that helps you build and manage your online store easily.",
      btnText: "Start Selling Now!",
      link: "https://wcart.io/?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell",
      color: "dark",
      icon: <FaShoppingCart />,
    },
    {
      title: "AI AD GEN",
      desc: "AI-powered tool that creates digital ads instantly for any business or campaign.",
      btnText: "Create Smart Ads Now!",
      link: "https://adgenai.webnexs.com/get-started/?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell",
      color: "warning",
      icon: <FaRobot />,
    },
    {
      title: "Hire dedicated marketers",
      desc: "Hire dedicated marketers to plan and manage your brand’s growth.",
      btnText: "Level Up Your Marketing Today!",
      link: "https://www.webnexs.com/digital-marketing-services.php?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell",
      color: "success",
      icon: <FaBullhorn />,
    },
    {
      title: "Hire dedicated developers",
      desc: "Hire dedicated developers to build and improve your digital products.",
      btnText: "Start Your Development Today!",
      link: "https://www.webnexs.com/hire-dedicated-developer.php?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell",
      color: "info",
      icon: <FaCode />,
    },
    {
      title: "Hire dedicated designers",
      desc: "Hire dedicated designers to bring fresh creative ideas to your brand.",
      btnText: "Start Your Design Project Today!",
      link: "https://www.webnexs.com/hire-dedicated-graphic-designer.php?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell",
      color: "danger",
      icon: <FaPaintBrush />,
    },
  ];


  let username = localStorage.getItem("username");
  let role = localStorage.getItem("role");
  if (username) {
    username = username.charAt(0).toUpperCase() + username.slice(1);
  }

  const [dashboard, setDashboard] = useState({});
  let userId = dashboard.user_details;

  const [customerSummary, setCustomerSummary] = useState({});
  const [setupProgress, setSetupProgress] = useState({
    transcoding: false,
    emailConfig: false,
    rtmpConfig: false,
    paymentConfig: false,
    cdnConfig: false,
    siteSettings: false,
    contentUpload: false,
    storefront: false,
    subscriptionPlans: false,
    userManagement: false
  });
  const [overallProgress, setOverallProgress] = useState(0);
  const [isCheckingProgress, setIsCheckingProgress] = useState(false);
  const [completedSteps, setCompletedSteps] = useState(0);
  const [totalSteps, setTotalSteps] = useState(10);
  const [isStepsOpen, setIsStepsOpen] = useState(true);

  // Download Guides configuration
  const earnGuideUrl = process.env.REACT_APP_DASHBOARD_PDF_EARN_GUIDE_URL || '/guides/earn-1-lakh.pdf';
  const userGuideUrl = process.env.REACT_APP_DASHBOARD_PDF_USER_GUIDE_URL || '/guides/video-library-user-guide.pdf';
  const playoutGuideUrl = process.env.REACT_APP_DASHBOARD_PDF_USER_GUIDE_URL || '/guides/playout-user-guide.pdf';

  const downloadPdf = (url, fallbackName = 'document.pdf') => {
    try {
      const link = document.createElement('a');
      link.href = url;
      // Derive filename from URL if possible; fallback to provided name
      const last = (url || '').split('/').pop();
      const fileName = (last && last.includes('.')) ? last : fallbackName;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      // Fallback to opening in a new tab
      window.open(url, '_blank', 'noopener');
    }
  };

  // Setup steps configuration
  const setupSteps = [
    {
      key: 'transcoding',
      title: 'Enable Transcoding',
      description: 'Configure video transcoding settings for optimal streaming quality.',
      link: '/site/transcoding-setting',
      linkText: 'Configure Transcoding',
      Icon: FiVideo,
      color: 'bg-primary-subtle text-primary'
    },
    {
      key: 'emailConfig',
      title: 'Email Configuration',
      description: 'Set up SMTP settings for notifications and user communications.',
      link: '/email_settings',
      linkText: 'Configure Email',
      Icon: FiMail,
      color: 'bg-info-subtle text-info'
    },
    {
      key: 'rtmpConfig',
      title: 'Live Stream RTMP Setup',
      description: 'Configure RTMP settings for live streaming capabilities.',
      link: '/site/rtmpurl',
      linkText: 'Setup RTMP',
      Icon: FiPlayCircle,
      color: 'bg-danger-subtle text-danger'
    },
    {
      key: 'paymentConfig',
      title: 'Payment Gateway Setup',
      description: 'Configure payment processors for subscription billing.',
      link: '/payment_settings',
      linkText: 'Setup Payments',
      Icon: FiCreditCard,
      color: 'bg-success-subtle text-success'
    },
    {
      key: 'cdnConfig',
      title: 'CDN Configuration',
      description: 'Set up Content Delivery Network for faster content distribution.',
      link: '/site/script-setting',
      linkText: 'Configure CDN',
      Icon: FiGlobe,
      color: 'bg-warning-subtle text-warning'
    },
    {
      key: 'siteSettings',
      title: 'Site Settings Setup',
      description: 'Configure basic site settings and theme preferences.',
      link: '/site/site-setting',
      linkText: 'Setup Site',
      Icon: FiSettings,
      color: 'bg-secondary-subtle text-secondary'
    },
    {
      key: 'contentUpload',
      title: 'Upload Content',
      description: 'Add your first video content to the platform.',
      link: '/add-library',
      linkText: 'Upload Content',
      Icon: FiUpload,
      color: 'bg-primary-subtle text-primary'
    },
    {
      key: 'storefront',
      title: 'Customize Storefront',
      description: 'Configure your brand, logo, and storefront appearance.',
      link: '/settings',
      linkText: 'Customize Store',
      Icon: FiDatabase,
      color: 'bg-info-subtle text-info'
    },
    {
      key: 'subscriptionPlans',
      title: 'Create Subscription Plans',
      description: 'Set up pricing tiers and subscription options.',
      link: '/subscription-plans',
      linkText: 'Add Plans',
      Icon: LuCrown,
      color: 'bg-warning-subtle text-warning'
    },
    {
      key: 'userManagement',
      title: 'User Management Setup',
      description: 'Configure user roles, permissions, and access controls.',
      link: '/users',
      linkText: 'Setup Users',
      Icon: FiUsers,
      color: 'bg-success-subtle text-success'
    }
  ];


  // Determine product type similar to Sidebar
  const productTypeFromEnv = process.env.REACT_APP_DEPLOYMENT_PRODUCT_TYPE;
  const productType = (productTypeFromEnv && productTypeFromEnv !== 'null' && productTypeFromEnv !== 'undefined')
    ? productTypeFromEnv
    : (adminSetting?.productType || undefined);

  // Map product types to the subset of steps they should show
  const productTypeStepsMap = {
    video_library: ['contentUpload', 'emailConfig'],
    playout: ['contentUpload', 'emailConfig', 'rtmpConfig'],
  };

  const productTypefromPermission = Number(userDetails?.permission_id) === 4 ? "video_library" : Number(userDetails?.permission_id) === 5 ? "playout" : "full_package"
  const filteredSetupSteps = (productTypefromPermission && productTypeStepsMap[productTypefromPermission])
    ? setupSteps.filter(s => productTypeStepsMap[productTypefromPermission].includes(s.key))
    : setupSteps;

  // Product type gating flags
  const normalizedProductType = (productType || '').toLowerCase();
  const isFullPackageOrNull = !normalizedProductType || ['full-package', 'full_package', 'fullpackage'].includes(normalizedProductType);
  const shouldShowVideoLibraryGuides = normalizedProductType === 'video_library' || normalizedProductType === 'video-library';
  const shouldShowPlayoutGuides = normalizedProductType === 'playout' || normalizedProductType === 'product';
  const getTitle = () => {
    if (Number(userDetails?.permission_id) === 4) return "Video Library";
    if (Number(userDetails?.permission_id) === 5) return "Playout";
    if (Number(userDetails?.permission_id) !== 4 || Number(userDetails?.permission_id) !== 5) return "Full Package";
    return "Unknown Product";
  };

  const full_package_videos = [
    { url: "https://www.youtube.com/embed/yxz-FTrsWzo", title: "Flicknexs - Frontend", productTypes: ["full_package"] },
    { url: "https://www.youtube.com/embed/kn0xUg14lZk", title: "Email Configuration", productTypes: ["full_package"] },
    { url: "https://www.youtube.com/embed/U1IpL9wc1Z8", title: "Flicknexs - Backend", productTypes: ["full_package"] },
  ];
  const playout_package_videos = [
    { url: "https://www.youtube.com/embed/AHtTv4u1Po0?si=HkBmZ-LXNIUSCce6", title: "How to Schedule Playlist in Flicknexs Playout", productTypes: ["playout"] },
    { url: "https://www.youtube.com/embed/YY1N9lMSjNA?si=K8AYKBQXIkn2tSQY", title: "फ्लिकनेक्स प्लेआउट में प्लेलिस्ट कैसे शेड्यूल करें", productTypes: ["playout"] },
  ];

  const filteredVideos = Number(userDetails?.permission_id) === 5 ? playout_package_videos : adminPermission ? full_package_videos : null


  const showCharts = isFullPackageOrNull; // show charts only for full-package or null

  // Compute progress based on filtered steps
  const displayTotalSteps = filteredSetupSteps?.length;
  const displayCompletedSteps = filteredSetupSteps?.reduce((acc, step) => acc + (setupProgress[step.key] ? 1 : 0), 0);
  const displayOverallProgress = displayTotalSteps ? Math.round((displayCompletedSteps / displayTotalSteps) * 100) : 0;

  // Function to fetch setup progress from API
  const fetchSetupProgress = async () => {
    try {
      setIsCheckingProgress(true);

      const response = await axios.get(`${finalRouteApi}/setup-progress`, {
        headers: adminApiHeader
      });

      if (response.data.status) {
        const { progress, overallProgress, completedSteps, totalSteps } = response.data.data;

        setSetupProgress(progress);
        setOverallProgress(overallProgress);
        setCompletedSteps(completedSteps);
        setTotalSteps(totalSteps);
      }
    } catch (error) {
      console.error('❌ Error fetching setup progress:', error);
      // Set fallback values on error
      setOverallProgress(0);
      setCompletedSteps(0);
    } finally {
      setIsCheckingProgress(false);
    }
  };

  // Effect to fetch setup progress on component mount and dashboard changes
  // Effect removed or consolidated to initDashboard
  // useEffect(() => {
  //   fetchSetupProgress();
  // }, [dashboard]);


  // Function to refresh setup progress
  const refreshSetupProgress = () => {
    fetchSetupProgress();
  };

  // Add event listener for when user returns to dashboard (to refresh progress)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Page became visible, refresh progress
        refreshSetupProgress();
      }
    };

    const handleFocus = () => {
      // Window gained focus, refresh progress
      refreshSetupProgress();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);


  // daysLeft logic handled by context

  const SalesTable = ({ title, data }) => (
    <>
      <div>
        <h6 className="mb-0 text-uppercase fw-semibold">
          {title}
        </h6>
      </div>
      <div className="card shadow-sm border-0 rounded-4 overflow-hidden bg-light bg-opacity-75 mb-4">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-borderless table-hover align-middle mb-0">
              <thead className="text-secondary small text-uppercase bg-light">
                <tr>
                  <th>Date</th>
                  <th>Source</th>
                  <th>Source ID</th>
                  <th>Title</th>
                  <th className="text-end">Amount (₹)</th>
                  <th className="text-end">Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index} className="border-bottom">
                      <td>{item.date}</td>
                      <td>{item.source}</td>
                      <td>{item.source_id}</td>
                      <td className="theme-text-color">{item.title || "N/A"}</td>
                      <td className="text-end">
                        <span className="badge bg-success">₹{item.amount}</span>
                      </td>
                      <td className="text-end fw-semibold">₹{item.total}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-3 theme-text-color">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
  const getCurrentWeekData = (data) => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    return data
      .filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= startOfWeek && itemDate <= endOfWeek;
      })
      .map((item) => ({
        x: new Date(item.date).getTime(),
        y: item.count,
      }));
  };



  function HelpdeskFloatingButton() {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
      <div
        className="position-fixed"
        style={{ bottom: "60px", right: "5px", zIndex: 1050 }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <Link
          to="https://helpdesk.flicknexs.com"
          className="d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle"
          style={{ width: 48, height: 48 }}
        >
          <FiHelpCircle size={24} />
        </Link>

        {showTooltip && (
          <div
            style={{
              position: "absolute",
              bottom: "60px",
              right: 0,
              background: "#fff",
              padding: "16px",
              border: "1px solid #dee2e6",
              borderRadius: "12px",
              width: "280px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
              color: "#333",
            }}
          >
            <h6 className="mb-1 fw-bold text-dark">
              {t(`Need Help?`)}
            </h6>
            <p className="mb-2 small theme-text-color">
              {t(`  Our support team is here to assist you with setup, features, and issues.`)}
            </p>
            <Link


              to="https://helpdesk.flicknexs.com"
              className="text-decoration-none text-primary fw-semibold small"
            >
              Go to Helpdesk →
            </Link>
          </div>
        )}
      </div>
    );
  }


  const [combinedChartSeries, setCombinedChartSeries] = useState([
    { name: "No Data", data: [] }
  ]);

  const [combinedChartOptions, setCombinedChartOptions] = useState({
    chart: {
      type: "line",
      height: 400,
    },
    xaxis: {
      categories: [],
    },
  });

  useEffect(() => {
    if (!dashboard) return;

    const processMonthlyData = (dataArray, valueKey) => {
      const dataByMonth = {};
      dataArray.forEach((item) => {
        const date = new Date(item.createdAt);
        const monthKey = date.toLocaleString("default", { month: "short", year: "numeric" });
        dataByMonth[monthKey] = (dataByMonth[monthKey] || 0) + item[valueKey];
      });

      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      const allMonths = Array.from({ length: currentMonth + 1 }, (_, i) => {
        const date = new Date(currentYear, i);
        return date.toLocaleString("default", { month: "short", year: "numeric" });
      });

      const values = allMonths.map((month) => dataByMonth[month] || 0);
      return { labels: allMonths, data: values };
    };

    const purchases = dashboard.Number_of_purchases_contents?.length
      ? processMonthlyData(dashboard.Number_of_purchases_contents, "purchase_count")
      : null;

    const earnings = dashboard.Number_of_earnings_on_contents?.length
      ? processMonthlyData(dashboard.Number_of_earnings_on_contents, "total_earnings")
      : null;

    const subscriptionCount = dashboard.Number_of_subscription_on_count?.length
      ? processMonthlyData(dashboard.Number_of_subscription_on_count, "subscription_count")
      : null;

    const subscriptionEarnings = dashboard.Number_of_subscription_earnings?.length
      ? processMonthlyData(dashboard.Number_of_subscription_earnings, "total_earnings")
      : null;

    const hasData = purchases || earnings || subscriptionCount || subscriptionEarnings;

    if (!hasData) {
      setCombinedChartSeries([
        { name: "No Data", data: [] }
      ]);
      return;
    }

    const combinedLabels = purchases?.labels || earnings?.labels || subscriptionCount?.labels || subscriptionEarnings?.labels;

    const series = [
      {
        name: "PPV Purchases",
        type: "column",
        data: purchases?.data || [],
        yAxisIndex: 0,
      },
      {
        name: "Subscriptions",
        type: "column",
        data: subscriptionCount?.data || [],
        yAxisIndex: 0,
      },
      {
        name: "PPV Earnings",
        type: "line",
        data: earnings?.data || [],
        yAxisIndex: 1,
      },
      {
        name: "Subscription Earnings",
        type: "line",
        data: subscriptionEarnings?.data || [],
        yAxisIndex: 1,
      },
    ];



    const strokeWidths = series?.map((s) => (s.type === "line" || s.type === "area" ? 3 : 0));

    setCombinedChartOptions({
      chart: {
        type: "line",
        height: 400,
        toolbar: { show: false },
        zoom: { enabled: false },
        fontFamily: "Inter, sans-serif",
        stacked: false,
      },
      noData: {
        text: "No data available",
        align: 'center',
        verticalAlign: 'middle',
        style: {
          color: '#999',
          fontSize: '16px',
        },
      },
      stroke: {
        width: [0, 0, 3, 3],
        curve: "smooth",
        dashArray: [0, 0, 0, 6],
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          borderRadius: 6,
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: combinedLabels,
        labels: {
          rotate: -45,
          style: { fontSize: "13px", color: "#1e3a8a" },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: [
        {
          title: { text: "Count", style: { fontSize: "13px", color: "#1e3a8a" } },
          labels: {
            formatter: (val) => Math.round(val || 0),
            style: { fontSize: "12px", color: "#1e3a8a" },
          },
          min: 0,
        },
        {
          opposite: true,
          title: { text: "Earnings", style: { fontSize: "13px", color: "#1e3a8a" } },
          labels: {
            formatter: (val) => Math.round(val || 0),
            style: { fontSize: "12px", color: "#1e3a8a" },
          },
          min: 0,
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
        theme: "light",
        x: {
          formatter: (val, opts) => {
            if (opts && opts.dataPointIndex !== undefined && combinedLabels) {
              return combinedLabels[opts.dataPointIndex] || val;
            }
            return val;
          },
        },
        y: {
          formatter: (val) => Math.round(val || 0),
        },
      },
      colors: [
        "#9ED4FD", // PPV Purchases
        "#64A7D1", // Subscriptions
        "#3B82F6", // PPV Earnings
        "#1D4ED8"  // Subscription Earnings (sharper blue)
      ],
      fill: {
        type: ["solid", "solid", "solid", "solid"], // remove gradient
        gradient: {
          shade: "light",
          type: "vertical",
          shadeIntensity: 0.25,
          opacityFrom: 0.6,
          opacityTo: 0.05,
          stops: [0, 90, 100],
        },
        opacity: [1, 1, 1, 1],
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        labels: { colors: "#1e3a8a" },
        itemMargin: { horizontal: 10 },
      },
      grid: {
        borderColor: "#e0f2fe",
        strokeDashArray: 3,
      },
    });

  }, [dashboard]);

  const { accessToken } = useMyContext();

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };


  const refreshCdnUsage = async () => {
    if (cdnRefreshing) return;
    setCdnRefreshing(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/bunny-cdn-usage?force=1`,
        { headers }
      );
      setCdnUsage(res.data || { data: {}, storageLimit: 0 });
    } catch (err) {
      console.error('[refreshCdnUsage]', err?.message);
    } finally {
      setCdnRefreshing(false);
    }
  };

  useEffect(() => {

      const initDashboard = async () => {
        // Parallelize all dashboard-related fetches
        const promises = [
          axios.get(`${process.env.REACT_APP_Baseurl}/admin/dashboard`, { headers }),
          axios.get(`${process.env.REACT_APP_Baseurl}/admin/customer-summary-dashboard`, { headers }),
          axios.get(`${process.env.REACT_APP_Base_Webnexs_URL}/view_banner/e4e1hzm8fkz3pa`),
          axios.get(`${process.env.REACT_APP_Baseurl}/admin/Site-ThemeSetting/index`, { headers }),
          axios.get(`${process.env.REACT_APP_Baseurl}/admin/bunny-cdn-usage`, { headers }),
          axios.get(`${finalRouteApi}/setup-progress`, { headers: adminApiHeader })
        ];

        // Add storage bandwidth promise if orgDetails is available
        if (orgDetails?.deployment_id && orgDetails?.deployment_org_id) {
          promises.push(
            fetch(`${process.env.REACT_APP_Base_Webnexs_URL}/userapi/get_deployment_storage`, {
              method: "POST",
              headers: { Accept: "application/json", "Content-Type": "application/json" },
              body: JSON.stringify({
                deployment_id: orgDetails?.deployment_id,
                org_id: orgDetails?.deployment_org_id,
              }),
            }).then(res => res.json())
          );
        }

        try {
          const results = await Promise.allSettled(promises);
          
          const dashRes = results[0];
          const custRes = results[1];
          const bannerRes = results[2];
          const themeRes = results[3];
          const cdnRes = results[4];
          const progressRes = results[5];
          const storageRes = results[6];

          if (dashRes.status === 'fulfilled') setDashboard(dashRes.value.data.data || {});
          if (custRes.status === 'fulfilled') setCustomerSummary(custRes.value.data || {});
          if (bannerRes.status === 'fulfilled') {
            const result = bannerRes.value.data?.banners?.[0]?.banner_image;
            if (result) setBanner(result);
          }
          if (themeRes.status === 'fulfilled') setThemeSettings(themeRes.value.data?.Site_theme_setting?.[0]);
          if (progressRes.status === 'fulfilled' && progressRes.value.data.status) {
            const { progress, overallProgress, completedSteps, totalSteps } = progressRes.value.data.data;
            setSetupProgress(progress);
            setOverallProgress(overallProgress);
            setCompletedSteps(completedSteps);
            setTotalSteps(totalSteps);
          }

          if (cdnRes?.status === 'fulfilled') {
            setCdnUsage(cdnRes.value.data || { data: {}, storageLimit: 0 });
          }

          if (storageRes && storageRes.status === 'fulfilled' && storageRes.value.success) {
            setStorageData(storageRes.value);
          }
        } catch (error) {
          console.error("Dashboard initialization error:", error);
        }
      };

      if (onlyPermission?.includes(1)) {
        initDashboard();
      }
    }, [onlyPermission, orgDetails]);

    const isSubscriptionExpired = isSubscriptionEnded();

    const totalGB = storageData?.total_storage_parsed_gb;
    const usedGB = storageData?.storage_used_gb;
    const usedMB = storageData?.storage_used_mb;
    const remainingGB = storageData?.available_storage_gb;
    const remainingMB = storageData?.available_storage_mb;

    const usedPercent = ((usedGB / totalGB) * 100)?.toFixed(0);
    const remainingPercent = ((remainingGB / totalGB) * 100)?.toFixed(0);
    
    // Storage Calculations (Now from API summary)
    const formattedUsed = cdnUsage?.summary?.formattedTotalUsed || "0 MB";
    const formattedRemaining = cdnUsage?.summary?.formattedRemaining || "0 MB";
    const formattedLimit = cdnUsage?.summary?.formattedLimit || "0 GB";
    const storageUsagePercentage = parseFloat(cdnUsage?.summary?.storageUsagePercentage || 0);

    // Bandwidth (from summary.bandwidth)
    const bw = cdnUsage?.summary?.bandwidth || {};
    const totalBandwidthGB      = bw.totalGB           || 0;
    const bandwidthLimitGB      = bw.limitGB            || 0;
    const bwUsagePercentage     = parseFloat(bw.usagePercentage || 0);
    const formattedBandwidth    = bw.formattedTotal     || "0 MB";
    const formattedBwLimit      = bw.formattedLimit     || "0 GB";
    const formattedBwRemaining  = bw.formattedRemaining || "0 MB";
    // per-CDN breakdown (for modal only)
    const bwStorageCdnGB  = bw.storageCdnGB  || 0;
    const bwStreamCdnGB   = bw.streamCdnGB   || 0;
    const bwFrontendCdnGB = bw.frontendCdnGB || 0;

    // Monthly bandwidth history (for modal chart)
    const bandwidthHistory = cdnUsage?.bandwidthHistory || [];

    const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    const bwHistoryChartOptions = useMemo(() => ({
      chart: { type: 'area', fontFamily: 'Inter, sans-serif', toolbar: { show: false }, zoom: { enabled: false } },
      stroke: { curve: 'smooth', width: 2 },
      fill: { type: 'gradient', gradient: { opacityFrom: 0.5, opacityTo: 0.05, type: 'vertical' } },
      xaxis: {
        categories: bandwidthHistory.map(r => `${MONTH_NAMES[r.month - 1]} ${r.year}`),
        labels: { style: { fontSize: '11px' } },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: { labels: { formatter: v => v.toFixed(2) + ' GB', style: { fontSize: '11px' } } },
      colors: ['#f59e0b'],
      dataLabels: { enabled: false },
      markers: { size: 4, hover: { size: 6 } },
      tooltip: { y: { formatter: v => (v || 0).toFixed(2) + ' GB' } },
      grid: { borderColor: '#f1f5f9', strokeDashArray: 3 },
    }), [bandwidthHistory]);

    const bwHistoryChartSeries = useMemo(() => [
      { name: 'Total CDN Bandwidth', data: bandwidthHistory.map(r => parseFloat(r.total_gb) || 0) },
    ], [bandwidthHistory]);

    const storageDonutSeries = (cdnUsage?.summary?.chartSeries || [0, 0, 100]).map(v => parseFloat(parseFloat(v || 0).toFixed(2)));
    const storageDonutLabels = cdnUsage?.summary?.chartLabels || ["Transcoding Files", "Assets", "Available Space"];

    const storageDonutOptions = useMemo(() => ({
      chart: { type: 'donut', fontFamily: 'Inter, sans-serif' },
      labels: cdnUsage?.summary?.chartLabels || ['Transcoding Files', 'Assets', 'Available Space'],
      colors: ['#0A579E', '#249CFF', '#f1f5f9'],
      legend: { position: 'bottom', fontSize: '13px', markers: { radius: 12 } },
      stroke: { show: false },
      dataLabels: { enabled: false },
      plotOptions: {
        pie: {
          donut: {
            size: '75%',
            labels: {
              show: true,
              name: { show: true, fontSize: '14px', color: '#64748b' },
              value: {
                show: true,
                fontSize: '20px',
                fontWeight: 700,
                color: '#1e293b',
                formatter: (val) => `${parseFloat(val).toFixed(2)} GB`
              },
              total: {
                show: true,
                label: 'Total Used',
                fontSize: '14px',
                color: '#64748b',
                formatter: () => `${cdnUsage?.summary?.totalUsedGB?.toFixed(2)} GB`
              }
            }
          }
        }
      },
    }), [cdnUsage]);

    const trendChartSeries = useMemo(() => [
      {
        name: 'Assets Storage',
        data: [
          (cdnUsage?.summary?.usedStorageAssetsGB * 0.7).toFixed(2),
          (cdnUsage?.summary?.usedStorageAssetsGB * 0.8).toFixed(2),
          (cdnUsage?.summary?.usedStorageAssetsGB * 0.85).toFixed(2),
          (cdnUsage?.summary?.usedStorageAssetsGB * 0.92).toFixed(2),
          (cdnUsage?.summary?.usedStorageAssetsGB * 0.98).toFixed(2),
          cdnUsage?.summary?.usedStorageAssetsGB || 0
        ]
      },
      {
        name: 'Stream Storage',
        data: [
          (cdnUsage?.summary?.streamStorageGB * 0.6).toFixed(2),
          (cdnUsage?.summary?.streamStorageGB * 0.75).toFixed(2),
          (cdnUsage?.summary?.streamStorageGB * 0.8).toFixed(2),
          (cdnUsage?.summary?.streamStorageGB * 0.88).toFixed(2),
          (cdnUsage?.summary?.streamStorageGB * 0.95).toFixed(2),
          cdnUsage?.summary?.streamStorageGB || 0
        ]
      }
    ], [cdnUsage]);



    const donutData = {
      "Videos": dashboard?.current_videos_count || 0,
      "Livestream": dashboard?.current_livestream_count || 0,
      "Audios": dashboard?.current_audios_count || 0,
      "Series": dashboard?.current_series_count || 0,
    };

    const donutseries = Object.values(donutData);
    const donutlabels = Object.keys(donutData);

    const donutoptions = {
      chart: {
        type: 'donut',
      },
      labels: donutlabels,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      legend: {
        position: 'right',
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          if (opts && opts.w && opts.w.globals && opts.w.globals.series && opts.seriesIndex !== undefined) {
            return opts.w.globals.series[opts.seriesIndex];
          }
          return val;
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
              },
              value: {
                show: true,
                formatter: function (val, opts) {
                  if (opts && opts.w && opts.w.globals && opts.w.globals.series && opts.seriesIndex !== undefined) {
                    return opts.w.globals.series[opts.seriesIndex];
                  }
                  return val;
                },
              },
              total: {
                show: true,
                label: 'Total',
                formatter: function (w) {
                  if (w && w.globals && w.globals.seriesTotals) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  }
                  return '0';
                },
              },
            },
          },
        },
      },
      colors: ['#0A579E', '#1578CF', '#249CFF', '#77C2FE', '#0d47a1']
    };

    const registeredData = customerSummary?.monthSummaryRegisteredUsersGraph ?? [];
    const subscribedData = customerSummary?.monthSummarySubscriberUsersGraph ?? [];

    const months = registeredData.map(item => item?.month ?? '');
    const registeredCounts = registeredData.map(item => item?.count ?? 0);
    const subscribedCounts = subscribedData.map(item => item?.count ?? 0);
    const hasGraphData = months.length > 0;

    const combinedUsersSeries = [
      {
        name: "Registered Users",
        type: "line",
        data: registeredCounts
      },
      {
        name: "Subscribed Users",
        type: "area",
        data: subscribedCounts
      }
    ];

    const combinedUsersOptions = {
      chart: {
        type: 'line',
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false
          }
        }
      },
      stroke: {
        curve: 'smooth',
        width: [2, 2]
      },
      fill: {
        type: ['solid', 'gradient'],
        gradient: {
          shadeIntensity: 0.7,
          opacityFrom: 0.4,
          opacityTo: 0.05,
          stops: [0, 90, 100]
        }
      },
      tooltip: {
        enabled: true,
        theme: "dark",
        shared: true,
        intersect: false,
        x: {
          show: true,
          formatter: (val, opts) => {
            if (opts && opts.dataPointIndex !== undefined && months) {
              return months[opts.dataPointIndex] || '';
            }
            return '';
          }
        },
        y: {
          formatter: (val, { seriesIndex }) => {
            const wholeNumber = Math.floor(val);
            return seriesIndex === 0 ? `${wholeNumber} registered` : `${wholeNumber} subscribers`;
          }
        }
      },
      // markers: {
      //   size: [3, 0]
      // },
      markers: {
        size: [0, 0, 0, 5],
        colors: "#1D4ED8",
        strokeColors: "#1D4ED8",
        strokeWidth: 2,
        hover: {
          size: 6,
        },
      },

      colors: ['#2196f3', '#0A579E'],
      xaxis: {
        categories: months,
        labels: {
          style: {
            colors: '#999'
          }
        }
      },
      yaxis: [
        {
          title: {
            text: 'Registered Users',
            style: {
              color: '#2196f3'
            }
          },
          labels: {
            style: {
              colors: '#2196f3'
            },
            formatter: (val) => {
              return Math.floor(val).toString();
            }
          }
        },
        {
          opposite: true,
          title: {
            text: 'Subscribed Users',
            style: {
              color: '#0A579E'
            }
          },
          labels: {
            style: {
              colors: '#0A579E'
            },
            formatter: (val) => {
              return Math.floor(val).toString();
            }
          }
        }
      ],
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        labels: {
          colors: '#999'
        }
      },
      grid: {
        borderColor: '#e0e0e0',
        strokeDashArray: 3
      }
    };

    return (

      <>

        {role !== '4' && <div>

          <>
            <section>
              <div className=" m-0 p-0">
                <div className="container-fluid">
                  <div className="p-3">
                    <h3 className="mb-2">{t(`Good day, ${username}!`)}</h3>
                    <MessageSubHeading text={"Explore your streaming insights and see how your audience is engaging with your content."} className="theme-text-color flex-grow-1" />
                  </div>

                  {isHighlightActive && (
                    <div className="cta-highlight-overlay" onClick={() => setIsHighlightActive(false)}></div>
                  )}

                  {showPlayoutCTA && (
                    <div className={`playout-cta-wrapper my-4 ${isHighlightActive ? 'cta-highlighted' : ''}`}>
                      <div className="card playout-cta-card border-0 shadow-sm rounded-5 overflow-hidden">
                        <div className="card-body p-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                          <div className="d-flex align-items-center gap-3">
                            <div className="playout-cta-icon-wrapper">
                              <FaTv size={30} className="text-primary" />
                              <div className="hand-gesture-ping">
                                <span className="hand-icon">👆</span>
                              </div>
                            </div>
                            <div>
                              <h5 className="mb-1 fw-bold">Ready to Launch Your TV Channel?</h5>
                              <p className="mb-0 theme-text-color">Explore the Playout feature and start scheduling your broadcast today.</p>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <button className="btn btn-outline-secondary px-4 rounded-pill" onClick={handleSkipPlayoutCTA}>
                              Skip
                            </button>
                            <button className="btn btn-primary px-4 rounded-pill d-flex align-items-center gap-2" onClick={handleExplorePlayout}>
                              Explore Playout <span className="explore-arrow">→</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {storageData && (
                    <div className="row g-3">
                      {[
                        { title: 'Total Storage', value: `${totalGB} GB / ${(totalGB * 1024)?.toFixed(2)} MB`, note: null, percent: 100, label: '100% Capacity' },
                        { title: 'Storage Used', value: `${usedGB?.toFixed(2)} GB / ${usedMB?.toFixed(2)} MB`, note: `Used out of ${totalGB} GB`, percent: usedPercent, label: `${usedPercent}% Used` },
                        { title: 'Storage Remaining', value: `${remainingGB?.toFixed(2)} GB / ${remainingMB?.toFixed(2)} MB`, note: `of ${totalGB} GB total`, percent: remainingPercent, label: `${remainingPercent}% Remaining` },
                      ].map(({ title, value, note, percent, label }) => (
                        <div className="col-md-4" key={title}>
                          <div className="card theme-bg-color theme-text-color p-1 h-100">
                            <div className="card-body d-flex flex-column p-3">
                              <h5 className="card-title">{title}</h5>
                              <h4 className="fw-bold">{value}</h4>
                              {note && <p className="theme-text-color mt-1">{note}</p>}
                              <div className="mt-auto">
                                <div className="progress mb-1" style={{ height: "8px" }}>
                                  <div className="progress-bar button-bg-color" role="progressbar" style={{ width: `${percent}%` }} />
                                </div>
                                <small>{label}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {visible && themeSettings?.subscription_flag === 1 && (
                    <div className={`trial-banner bg-primary-subtle ${closing ? "closing" : ""}`}>
                      <div className="row align-items-center w-100">
                        <div className="col-10">
                          <div className="trial-text">
                            {daysLeft > 0 ? (
                              <>
                                Your free trial will expire in <strong>{daysLeft} day{daysLeft > 1 ? "s" : ""}</strong>.{" "}
                                Don’t miss out — purchase a subscription today to keep enjoying all features without interruption.
                              </>
                            ) : (
                              <>
                                Your free trial has ended. Please purchase a subscription to continue using your account.
                              </>
                            )}
                          </div>
                        </div>

                        <div className="col-2 d-flex justify-content-end">
                          <div className="button-bg-color purchase-btn position-relative">
                            <Link to="/purchase-subscription" className="purchase-link ">
                              Purchase Now
                            </Link>
                            <span
                              className="close-inside"
                              onClick={(e) => {
                                e.stopPropagation();
                                setClosing(true);
                                setTimeout(() => setVisible(false), 800);
                              }}
                            >
                              <FiX />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {isSubscriptionExpired && (
                    <div className="alert alert-danger text-center p-4 rounded shadow-sm">
                      <FaExclamationTriangle
                        size={90} // adjust size
                        className="mb-3 text-warning"
                      />
                      <h6 className="fw-bold mb-2">{getExpiryMessage()}</h6>
                      <p className="mb-3 small text-danger">
                        Please renew to continue enjoying our services
                      </p>
                      <Link to="/purchase-subscription" className="renew-link warningColorBg">
                        Renew Now
                      </Link>
                    </div>
                  )}

                  {/* {onlyPermission?.includes(1) ? <> */}

                  <div className="productType-wrapper my-3">
                    <div className="card theme-bg-color p-3 mt-2 rounded-5">

                      <div className="d-flex justify-content-between align-items-center mb-3" style={{ maxWidth: "100%" }}>
                        <h5 className="fw-semibold mb-0 text-primary">{getTitle()}</h5>
                      </div>
                      <p className="theme-text-color small mb-3">
                        {Number(userDetails?.permission_id) === 4 &&
                          "Learn how to manage, monetize, and grow your video library effectively using Flicknexs tools."}
                        {Number(userDetails?.permission_id) === 5 &&
                          "Master 24x7 streaming with Flicknexs Playout — from scheduling to broadcasting effortlessly."}

                      </p>

                      <div className="d-flex flex-row gap-3 align-items-start flex-wrap">

                        {Number(userDetails?.permission_id) === 4 && (
                          <>
                            <div
                              className="p-3 border rounded-4 shadow-sm guide-card flex-fill d-flex align-items-start theme-bg-color theme-text-color"
                              role="button"
                              title="Guide How to Earn ₹1 Lakh in One Month with Flicknexs Video Library"
                              onClick={() =>
                                downloadPdf(
                                  earnGuideUrl,
                                  "Guide How to Earn ₹1 Lakh in One Month with Flicknexs Video Library.pdf"
                                )
                              }
                            >
                              <FiTrendingUp size={22} className="text-primary mt-1 me-3" />
                              <div style={{ maxWidth: "300px" }}>
                                <div className="fw-semibold text-truncate" title="Guide: How to Earn ₹1 Lakh in One Month with Flicknexs Video Library">
                                  Guide: How to Earn ₹1 Lakh in One Month with Flicknexs Video Library
                                </div>
                                <small className="theme-text-color text-truncate">Step-by-step revenue tips</small>
                              </div>

                            </div>

                            <div
                              className="p-3 border rounded-4 shadow-sm guide-card flex-fill d-flex align-items-start theme-bg-color theme-text-color"
                              role="button"
                              title="Flicknexs Video Library User Guide"
                              onClick={() => downloadPdf(userGuideUrl, "Flicknexs Video Library User Guide.pdf")}
                            >
                              <FiFileText size={22} className="text-primary mt-1 me-3" />
                              <div style={{ maxWidth: "300px" }}>
                                <div className="fw-semibold text-truncate">Flicknexs Video Library User Guide</div>
                                <small className="theme-text-color text-truncate">Setup and usage manual</small>
                              </div>
                            </div>
                          </>
                        )}

                        {Number(userDetails?.permission_id) === 5 && (
                          <div
                            className="p-3 border rounded-4 shadow-sm guide-card flex-fill d-flex align-items-start theme-bg-color theme-text-color"
                            role="button"
                            title="Flicknexs Playout Streaming User Guide"
                            onClick={() =>
                              downloadPdf(playoutGuideUrl, "Flicknexs Playout Streaming User Guide.pdf")
                            }
                          >
                            <FiFileText size={22} className="text-primary mt-1 me-3" />
                            <div style={{ maxWidth: "300px" }}>
                              <div className="fw-semibold text-truncate">Flicknexs Playout Streaming User Guide</div>
                              <small className="theme-text-color text-truncate">Setup and usage manual</small>
                            </div>
                          </div>
                        )}
                      </div>


                      {filteredVideos?.length > 0 && (
                        <div className="mt-4 d-flex flex-row flex-wrap gap-3">
                          {filteredVideos?.map((video, index) => (
                            <div key={index} style={{ flex: "1 1 calc(33.333% - 1rem)", minWidth: "280px" }}>
                              <div className="card border-0 shadow-sm rounded-4 overflow-hidden w-100 h-100">
                                <div className="ratio ratio-16x9">
                                  <iframe
                                    src={video.url}
                                    title={video.title}
                                    allowFullScreen
                                    style={{ border: 0 }}
                                  ></iframe>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}



                    </div>
                  </div>

                  {/* Platform Utilization Section */}
                  {Number(storage_settings?.bunnyCdnStorage) === 1 && (
                    <div className="px-3 mb-4 mt-4">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="card border-0 rounded-5 shadow-sm overflow-hidden bg-white">
                            <div className="card-body p-4 p-lg-5">
                              {/* Storage Utilization */}
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="mt-4 mt-md-0">
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                      <LuCrown className="text-warning" size={20} />
                                      <h5 className="fw-bold mb-0 text-dark">Storage Utilization</h5>
                                      <div className="ms-auto d-flex align-items-center gap-2">
                                        <button
                                          className="btn btn-link p-0 text-muted d-flex align-items-center text-decoration-none"
                                          onClick={refreshCdnUsage}
                                          disabled={cdnRefreshing}
                                          title="Refresh live data"
                                        >
                                          <FiRefreshCw size={17} style={cdnRefreshing ? { animation: 'spin 0.8s linear infinite' } : {}} />
                                        </button>
                                        <button
                                          className="btn btn-link p-0 text-primary d-flex align-items-center gap-1 text-decoration-none"
                                          onClick={() => setShowUsageModal(true)}
                                          title="Show Detailed Breakdown"
                                        >
                                          <FiInfo size={18} />
                                          <span className="small fw-semibold">Show Details</span>
                                        </button>
                                      </div>
                                    </div>
                                    <p className="text-muted mb-4 small">Monitor your storage consumption across transcoding files and assets.</p>

                                  <div className="d-flex flex-column gap-4">
                                    {/* Storage Used vs DB Limit */}
                                    <div className="p-4 border border-light rounded-4 bg-light shadow-sm">
                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="fw-bold text-dark small text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Storage Used</div>
                                        <span className="small fw-bold text-primary">{storageUsagePercentage}%</span>
                                      </div>
                                      <div className="h4 fw-bold text-dark mb-1">{formattedUsed}</div>
                                      <div className="small text-muted mb-3">of {formattedLimit} allocated</div>
                                      <div className="progress rounded-pill bg-white shadow-sm" style={{ height: '14px', border: '1px solid #edf2f7' }}>
                                        <div
                                          className="progress-bar bg-primary rounded-pill"
                                          role="progressbar"
                                          style={{ width: `${Math.min(100, storageUsagePercentage)}%`, transition: 'width 1s ease-in-out' }}
                                        />
                                      </div>
                                      <div className="d-flex justify-content-between mt-2">
                                        <span className="small text-muted">{formattedUsed} used</span>
                                        <span className="small text-success fw-semibold">{formattedRemaining} free</span>
                                      </div>
                                    </div>

                                    {/* Bandwidth Consumed vs Plan Limit */}
                                    <div className="p-4 border border-light rounded-4 bg-light shadow-sm">
                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                          <div className="fw-bold text-dark small text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Bandwidth Consumed</div>
                                          <div className="text-muted" style={{ fontSize: '10px' }}>This Month</div>
                                        </div>
                                        <span className="small fw-bold text-warning">{bwUsagePercentage}%</span>
                                      </div>
                                      <div className="h4 fw-bold text-dark mb-1">{formattedBandwidth}</div>
                                      <div className="small text-muted mb-3">of {formattedBwLimit} allocated</div>
                                      <div className="progress rounded-pill bg-white shadow-sm" style={{ height: '14px', border: '1px solid #edf2f7' }}>
                                        <div
                                          className="progress-bar bg-warning rounded-pill"
                                          role="progressbar"
                                          style={{ width: `${Math.min(100, bwUsagePercentage)}%`, transition: 'width 1s ease-in-out' }}
                                        />
                                      </div>
                                      <div className="d-flex justify-content-between mt-2">
                                        <span className="small text-muted">{formattedBandwidth} used</span>
                                        <span className="small text-success fw-semibold">{formattedBwRemaining} free</span>
                                      </div>

                                      {/* ── CDN Source Breakdown ────────────────────── */}
                                      <div className="mt-3 pt-3 border-top border-light">
                                        <button
                                          className="btn btn-link btn-sm p-0 text-decoration-none text-muted d-flex align-items-center gap-1"
                                          style={{ fontSize: '11px' }}
                                          onClick={() => setBwBreakdownOpen(prev => !prev)}
                                        >
                                          {bwBreakdownOpen ? '▲ Hide CDN source data' : '▼ CDN source data'}
                                        </button>

                                        {bwBreakdownOpen && (
                                          <div className="mt-3" style={{ fontSize: '12px' }}>
                                            {[
                                              { label: 'Storage CDN',  bwGB: bwStorageCdnGB,  color: '#0A579E', sources: cdnUsage?.cdnSources?.storageCdn  || [] },
                                              { label: 'Stream CDN',   bwGB: bwStreamCdnGB,   color: '#f59e0b', sources: cdnUsage?.cdnSources?.streamCdn   || [] },
                                              { label: 'Frontend CDN', bwGB: bwFrontendCdnGB, color: '#06b6d4', sources: cdnUsage?.cdnSources?.frontendCdn || [] },
                                            ].map(({ label, bwGB, color, sources }) => (
                                              <div key={label} className="d-flex justify-content-between align-items-start py-1 border-bottom border-light mb-1">
                                                <div className="d-flex align-items-start gap-1">
                                                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0, marginTop: 4 }} />
                                                  <div>
                                                    <div className="fw-semibold" style={{ color, fontSize: '12px' }}>{label}</div>
                                                    {sources.length > 0
                                                      ? <div className="text-muted" style={{ fontSize: '10px' }}>{sources[0]}</div>
                                                      : <div className="text-muted" style={{ fontSize: '10px' }}>No zone matched</div>
                                                    }
                                                  </div>
                                                </div>
                                                <span className="fw-bold text-dark text-nowrap ms-2" style={{ fontSize: '12px' }}>{parseFloat(bwGB).toFixed(2)} GB</span>
                                              </div>
                                            ))}
                                            <div className="d-flex justify-content-between fw-bold pt-2 border-top border-secondary border-opacity-25">
                                              <span>Total (this month)</span>
                                              <span className="text-warning">{totalBandwidthGB.toFixed(2)} GB</span>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {/* Overall Summary Row */}
                                    <div className="row g-3">
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="p-3 border border-light rounded-4 bg-white shadow-sm h-100 d-flex align-items-center justify-content-between">
                                          <div>
                                            <div className="small fw-semibold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>Total Used</div>
                                            <div className="h5 fw-bold text-dark mb-0">{formattedUsed}</div>
                                          </div>
                                          <div className="bg-light p-2 rounded-3 text-muted">
                                            <FiActivity size={18} />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="p-3 border border-light rounded-4 bg-white shadow-sm h-100 d-flex align-items-center justify-content-between">
                                          <div>
                                            <div className="small fw-semibold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>Remaining</div>
                                            <div className="h5 fw-bold text-success mb-0">{formattedRemaining}</div>
                                          </div>
                                          <div className="bg-success-subtle p-2 rounded-3 text-success">
                                            <FiCheckCircle size={18} />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-12">
                                        <div className="p-3 border border-light rounded-4 bg-white shadow-sm h-100 d-flex align-items-center justify-content-between">
                                          <div>
                                            <div className="small fw-semibold text-muted text-uppercase mb-1" style={{ fontSize: '10px' }}>Bandwidth</div>
                                            <div className="h5 fw-bold text-warning mb-0">{totalBandwidthGB.toFixed(2)} GB</div>
                                          </div>
                                          <div className="bg-warning-subtle p-2 rounded-3 text-warning">
                                            <FiZap size={18} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="theme-bg-color rounded-5 p-4 my-3">
                    <div className="row align-items-center mb-4">
                      <div className="col-md-8">
                        <MessageHeading text={"Platform Setup Progress"} classname="theme-text-color" noMargin border />
                        <MessageSubHeading text={`Complete these ${filteredSetupSteps?.length} essential steps to fully configure your streaming platform.`} className="theme-text-color flex-grow-1" />
                      </div>
                      <div className="col-md-4 text-md-end mt-3 mt-md-0">
                        <div className="d-flex align-items-center justify-content-md-end gap-3 mb-2">
                          <div className="progress-circle-container position-relative">
                            <svg width="60" height="60" className="transform-rotate-90">
                              <circle
                                cx="30"
                                cy="30"
                                r="25"
                                fill="none"
                                stroke="#e0e0e0"
                                strokeWidth="6"
                              />
                              <circle
                                cx="30"
                                cy="30"
                                r="25"
                                fill="none"
                                stroke={displayOverallProgress === 100 ? "#28a745" : "#007bff"}
                                strokeWidth="6"
                                strokeDasharray={`${(displayOverallProgress / 100) * 157} 157`}
                                strokeLinecap="round"
                                style={{ transition: "stroke-dasharray 0.5s ease-in-out" }}
                              />
                            </svg>
                            <div className="position-absolute top-50 start-50 translate-middle text-center">
                              <small className="fw-bold">{displayOverallProgress}%</small>
                            </div>
                          </div>
                          <div>
                            <div className="fw-semibold theme-text-color">{displayCompletedSteps}/{displayTotalSteps}</div>
                            <small className="theme-text-color">Steps Complete</small>
                          </div>
                        </div>
                        <div className="d-flex justify-content-md-end">
                          <div>
                            <button
                              type="button"
                              aria-label={isStepsOpen ? "Hide setup steps" : "Show setup steps"}
                              className={`btn ${isStepsOpen ? 'btn-outline-primary' : 'btn-primary'} d-inline-flex align-items-center gap-2`}
                              onClick={() => setIsStepsOpen(prev => !prev)}
                              style={{ padding: '8px 12px', fontSize: '14px' }}
                            >
                              <FiChevronDown style={{ transform: isStepsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
                              <span>{isStepsOpen ? 'Hide Setup Steps' : 'Show Setup Steps'}</span>
                            </button>
                          </div>
                          {/* <div className="mx-1">
                            <button className={`btn btn-primary`}
                              style={{ fontSize: '14px', padding: '8px 12px' }}
                              onClick={openTutorial}>
                              Watch Tutorial <FaYoutube size={20} className="" />
                            </button>
                          </div> */}
                        {/* <TutorialModal ref={tutorialRef} adminSetting={adminSetting} /> */}

                        </div>
                      </div>
                    </div>

                  {/* Progress Overview Bar */}
                    <div className="mb-4">
                      <div className="progress" style={{ height: "8px" }}>
                        <div
                          className={`progress-bar ${displayOverallProgress === 100 ? "bg-success" : ""}`}
                          role="progressbar"
                          style={{ width: `${displayOverallProgress}%`, transition: "width 0.5s ease-in-out" }}
                        >
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <small className="theme-text-color">Setup Progress</small>
                        <small className={displayOverallProgress === 100 ? "text-success fw-semibold" : "theme-text-color"}>
                          {displayOverallProgress === 100 ? "Setup Complete!" : `${displayOverallProgress}% Complete`}
                        </small>
                      </div>
                    </div>

                    {/* Setup Steps Grid (show all steps, completed show Reconfigure + Completed) */}
                    {isStepsOpen && (
                      <div className="row g-3">
                        {filteredSetupSteps?.map((step, idx) => {
                          const isCompleted = !!setupProgress[step.key];
                          return (
                            <div className="col-lg-4 col-md-6" key={step.key}>
                              <div className={`card border-0 theme-bg-color shadow h-100 position-relative`}
                                style={{ transition: "all 0.3s ease", borderLeft: isCompleted ? "4px solid #28a745" : "4px solid transparent" }}>
                                <div className="card-body d-flex flex-column p-3">
                                  <div className="d-flex align-items-start justify-content-between mb-2">
                                    <div className={`rounded-circle d-inline-flex justify-content-center align-items-center ${step.color}`}
                                      style={{ width: 40, height: 40, minWidth: 40 }}>
                                      <step.Icon className="" size={18} />
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      <div className={`rounded-circle d-flex align-items-center justify-content-center bg-light theme-text-color`}
                                        style={{ width: 24, height: 24, minWidth: 24 }}>
                                        <span style={{ fontSize: '10px' }}>{idx + 1}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="mb-2">
                                    <h6 className={`mb-1 theme-text-color`} style={{ fontSize: '14px' }}>
                                      {step.title}
                                    </h6>
                                    <p className="theme-text-color mb-0" style={{ fontSize: '12px', lineHeight: '1.4' }}>
                                      {step.description}
                                    </p>
                                  </div>

                                  <div className="mt-auto pt-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <Link
                                        to={step.link}
                                        className={`btn btn-sm btn-primary`}
                                        style={{ fontSize: '12px', padding: '6px 12px' }}
                                      >
                                        {isCompleted ? 'Reconfigure' : step.linkText}
                                      </Link>
                                      <span className={`badge ${isCompleted ? 'bg-success' : 'bg-secondary'} ms-2`}>
                                        {isCompleted ? 'Completed' : 'Pending'}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {displayOverallProgress === 100 && (
                      <div className="alert alert-success mt-4 border-0 shadow-sm">
                        <div className="d-flex align-items-center">
                          <FiCheckCircle className="text-success me-3" size={24} />
                          <div>
                            <h6 className="mb-1 text-success">Congratulations! Platform Setup Complete</h6>
                            <p className="mb-0 small">Your streaming platform is now fully configured and ready for use. You can still modify any settings as needed.</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {adminPermission && showCharts && (
                    <div className="row mt-2 d-flex">
                      <div className="col-lg-6 d-flex">
                        <div className="rounded-5 theme-bg-color p-4 mt-4 w-100 d-flex flex-column justify-content-between">
                          <MessageHeading border text={`Content's of ${username}!`} className="mb-3 text-center" />
                          <Chart options={donutoptions} series={donutseries} type="donut" width="100%" height={270} />
                        </div>
                      </div>

                      <div className="col-lg-6 d-flex">
                        <div className="rounded-5 theme-bg-color p-4 mt-4 w-100 d-flex flex-column justify-content-between position-relative">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <MessageHeading border text={"Users Overview"} noMargin padding />
                            <Link to="/analytics/users" >
                              <FiExternalLink size={18} style={{ color: "#1578CF" }} />
                            </Link>
                          </div>

                          {hasGraphData ? (
                            <Suspense fallback={<div className="text-center py-4">Loading Chart...</div>}>
                              <Chart
                                options={combinedUsersOptions}
                                series={combinedUsersSeries}
                                type="line"
                                height={250}
                              />
                            </Suspense>
                          ) : (
                            <div className="text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
                              <p className="theme-text-color">{t("No data available")}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {adminPermission && banner && (
                    <div className="mt-5 mb-3">
                      <Link to="https://wcart.io/?utm_source=flicknexs_admin&utm_medium=our_product&utm_campaign=upsell" target="_blank" rel="noopener noreferrer">
                        <img src={banner} className="d-block w-100" alt="banner" />
                      </Link>
                    </div>
                  )}

                  {adminPermission && showCharts && combinedChartOptions?.length > 0 && combinedChartSeries?.length > 0 && (
                    <div className="col-lg-12 col-md-12 pt-3">
                      <div className="rounded-5 theme-bg-color p-4 mt-4">
                        <div className="chart-container">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <MessageHeading text={"Payment Performance Overview"} className="theme-text-color mb-0" border noMargin padding />

                            <div className="d-flex gap-3 align-items-center">
                              <div className="d-flex align-items-center gap-1">
                                <MessageSubHeading text={"PPV Analytics:"} className="theme-text-color" noMargin />
                                <Link to="/analytics/ppv" >
                                  <FiExternalLink size={18} style={{ color: "#1578CF" }} />
                                </Link>
                              </div>
                              <div className="d-flex align-items-center gap-1">
                                <MessageSubHeading text={"Subscriber Analytics:"} className="theme-text-color" noMargin />
                                <Link to="/analytics/subscriber">
                                  <FiExternalLink size={18} style={{ color: "#1578CF" }} />
                                </Link>
                              </div>
                            </div>
                          </div>
                          <Suspense fallback={<div className="text-center py-4">Loading Chart...</div>}>
                            <Chart
                              options={combinedChartOptions}
                              series={combinedChartSeries}
                              type="line"
                              height={400}
                            />
                          </Suspense>
                        </div>
                      </div>
                    </div>
                  )}

                  {adminPermission &&
                    <div className="baseservices-section">
                      <h2 className="baseservices-title">Our Products and Services</h2>
                      <p className="baseservices-subtitle">
                        Explore our wide range of services and digital products.
                      </p>

                      <div className="baseservices-grid">
                        {baseservices.map((item, index) => (
                          <div className="baseservice-card" key={index}>
                            <div className={`baseservice-icon ${item.color}`}>
                              {item.icon}
                            </div>

                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>

                            <div className="baseservice-btn-wrap">
                              <a
                                href={item.link}
                                target="_blank"
                                rel="noreferrer"
                                className={`baseservice-btn ${item.color}`}
                              >
                                {item.btnText} <span className="arrow">→</span>
                              </a>

                            </div>
                          </div>
                        ))}
                      </div>

                    </div>
                  }


                  {/* <div className="row py-3">
                <div className="card h-100">
                  <div className="card-body d-flex flex-column">
                    <h6 className="text-center fw-bold mb-3">Current Statistics</h6>
                    <div className="row g-3 flex-grow-1">
                      {[
                        { label: "Today", value: dashboard?.purchasedToday ?? '-', Icon: TodaySVG },
                        { label: "This Month", value: dashboard?.purchasedThisMonth ?? '-', Icon: thisMonthSVG },
                        { label: "Last Month", value: dashboard?.purchasedLastMonth ?? '-', Icon: lastMonthSVG },
                        { label: "This Year", value: dashboard?.purchasedThisYear ?? '-', Icon: thisYearSVG },
                        { label: "Total Purchased", value: dashboard?.totalPurchased ?? '-', Icon: totalPurchasedSVG },
                        { label: "Free Access Promo", value: dashboard?.freeAccessWithPromotions ?? '-', Icon: freeAccessSVG },
                      ].map((stat, i) => (
                        <div className="col-12" key={i}>
                          <div className="d-flex align-items-center">
                            <stat.Icon size={24} className="me-2 text-primary" />
                            <div>
                              <div className="small theme-text-color">{stat.label}</div>
                              <div className="fw-bold">{stat.value}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
            </div>


            <div className="row py-3">
                <div className="card h-100">
                  <div className="card-body d-flex flex-column">
                    <h6 className="text-center fw-bold mb-3">Earnings Statistics</h6>
                    <div className="row g-3 flex-grow-1">
                      {[
                        { label: "Today", value: dashboard?.earnings_purchasedToday ?? '-', Icon: TodaySVG },
                        { label: "This Month", value: dashboard?.earnings_purchasedThisMonth ?? '-', Icon: thisMonthSVG },
                        { label: "Last Month", value: dashboard?.earnings_purchasedLastMonth ?? '-', Icon: lastMonthSVG },
                        { label: "This Year", value: dashboard?.earnings_purchasedThisYear ?? '-', Icon: thisYearSVG },
                        // { label: "Total Earnings", value: dashboard?.totalEarnings ?? '-', Icon: FaDollarSign },
                      ].map((stat, i) => (
                        <div className="col-12" key={i}>
                          <div className="d-flex align-items-center">
                            <stat.Icon size={24} className="me-2 text-primary" />
                            <div>
                              <div className="small theme-text-color">{stat.label}</div>
                              <div className="fw-bold">{stat.value}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
            </div> */}

                  {/* Tab Section */}

                  {/* <ul className="nav nav-tabs dashboard-tabs my-3" id="chartTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="monthly-registered-tab" data-bs-toggle="tab" data-bs-target="#monthly-registered" type="button" role="tab">
                  <i className="bi bi-person-plus me-1"></i> Monthly Registered
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="monthly-subscribed-tab" data-bs-toggle="tab" data-bs-target="#monthly-subscribed" type="button" role="tab">
                  <i className="bi bi-star-fill me-1"></i> Monthly Subscribed
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="weekly-registered-tab" data-bs-toggle="tab" data-bs-target="#weekly-registered" type="button" role="tab">
                  <i className="bi bi-calendar-week me-1"></i> Weekly Registered
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="weekly-subscribed-tab" data-bs-toggle="tab" data-bs-target="#weekly-subscribed" type="button" role="tab">
                  <i className="bi bi-calendar2-check me-1"></i> Weekly Subscribed
                </button>
              </li>
            </ul>


            <div className="tab-content" id="chartTabContent">
              <div className="tab-pane fade show active" id="monthly-registered" role="tabpanel">
                <div className="card shadow-sm p-3">
                  <h6 className="text-center">Monthly Registered User Stats</h6>

                  <div style={{ height: "350px" }}>
                    <Bar
                      data={monthlyRegisteredUsersData}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {
                          duration: 0,
                        },
                        plugins: {
                          legend: {
                            display: true,
                            position: "top",
                            labels: {
                              boxWidth: 12,
                              padding: 10,
                            },
                          },
                        },
                        layout: {
                          padding: {
                            top: 10,
                            bottom: 10,
                          },
                        },
                        scales: {
                          y: {
                            beginAtZero: true,
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="monthly-subscribed" role="tabpanel">
                <div className="card shadow-sm p-3">
                  <h6 className="text-center mb-3">Monthly Subscribed User Stats</h6>
                  <div style={{ height: "350px" }}>
                    <Bar
                      data={monthlySubscriberUsersData}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {
                          duration: 0,
                        },
                        plugins: {
                          legend: {
                            display: true,
                            position: "top",
                            labels: {
                              boxWidth: 12,
                              padding: 10,
                            },
                          },
                        },
                        layout: {
                          padding: {
                            top: 10,
                            bottom: 10,
                          },
                        },
                        scales: {
                          y: {
                            beginAtZero: true,
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="weekly-registered" role="tabpanel">
                <div className="card shadow-sm p-3">
                  <h6 className="text-center">Weekly Registered Users</h6>
                  <Chart options={options} series={weeklyRegisteredUsersSeries} type="line" height={350} />
                </div>
              </div>
              <div className="tab-pane fade" id="weekly-subscribed" role="tabpanel">
                <div className="card shadow-sm p-3">
                  <h6 className="text-center">Weekly Subscribed Users</h6>
                  <Chart options={options} series={weeklySubscriberUsersSeries} type="line" height={350} />
                </div>
              </div>
            </div> */}

                {/* <h4 className="sales-summary-title">CUSTOMER SUMMARY</h4>
            <div className="card">
              <div className="row mb-4">
                <div className="col-lg-6 col-md-6 col-sm-12 px-3 d-flex flex-column">
                  <div className="table-container mt-4" style={{ flexGrow: 1 }}>
                    <table className="table table-borderless mb-0" style={{ height: '100%' }}>
                      <thead>
                        <tr>
                          <th colSpan="2" className="text-center font-weight-bold">
                            Registered Users by Month
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(customerSummary?.monthSummaryRegisteredUsersGraph ?? []).map((user, index) => (
                          <tr key={index}>
                            <td>{user.month}</td>
                            <td>{user.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 px-3 d-flex flex-column">
                  <div className="table-container mt-4" style={{ flexGrow: 1 }}>
                    <table className="table table-borderless mb-0" style={{ height: '100%' }}>
                      <thead>
                        <tr>
                          <th colSpan="2" className="text-center font-weight-bold">
                            Subscribed Users by Month
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(customerSummary?.monthSummarySubscriberUsersGraph ?? []).map((user, index) => (
                          <tr key={index}>
                            <td>{user.month}</td>
                            <td>{user.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> */}
                {/* <div className="card">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="table-container mt-4" style={{ flexGrow: 1 }}>
                    <table className="table table-borderless mb-0" style={{ height: '100%' }}>
                      <thead>
                        <tr>
                          <th colSpan="3" className="text-center font-weight-bold">Weekly Resgistered Users</th>
                        </tr>
                        <tr>
                          <th>S.No</th>
                          <th>Email</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerSummary?.weekSummaryregisteredUsers?.length > 0 ? (
                          customerSummary.weekSummaryregisteredUsers.slice(0, 5).map((user, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{user.email}</td>
                              <td>{user.createdAt}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center theme-text-color">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {customerSummary?.weekSummaryregisteredUsers?.length > 0 && (
                    <div className="p-2">
                      <Link to="/users">
                        <span className="text-primary">View More</span>
                      </Link>
                    </div>
                  )}
                </div>

                <div className="col-md-6 mb-4">
                  <div className="table-container mt-4" style={{ flexGrow: 1 }}>
                    <table className="table table-borderless mb-0" style={{ height: '100%' }}>
                      <thead>
                        <tr>
                          <th colSpan="3" className="text-center font-weight-bold">Weekly Subscribed Users</th>
                        </tr>
                        <tr>
                          <th>S.No</th>
                          <th>Email</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerSummary?.weekSummarysubscriberUsers?.length > 0 ? (
                          customerSummary?.weekSummarysubscriberUsers ?? []).slice(0, 5).map((user, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{user.email}</td>
                              <td>{user.createdAt}</td>
                            </tr>
                          ))
                          : (
                            <tr>
                              <td colSpan="3" className="text-center theme-text-color">No data available</td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>

                  {customerSummary?.weekSummarysubscriberUsers?.length > 0 && (
                    <div className="p-2">
                      <Link to="/users">
                        <span className="text-primary">View More</span>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div> */}
                {/* <div className="card">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="table-container mt-4" style={{ flexGrow: 1 }}>
                    <table className="table table-borderless mb-0" style={{ height: '100%' }}>
                      <thead>
                        <tr>
                          <th colSpan="3" className="text-center font-weight-bold">Today Registered Users</th>
                        </tr>
                        <tr>
                          <th>S.No</th>
                          <th>Email</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerSummary?.todayRegisteredUsers?.length > 0 ? (
                          customerSummary?.todayRegisteredUsers ?? []).slice(0, 5).map((user, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{user.email}</td>
                              <td>{user.createdAt}</td>
                            </tr>
                          ))
                          : (
                            <tr>
                              <td colSpan="3" className="text-center theme-text-color">No data available</td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                  {customerSummary?.todayRegisteredUsers?.length > 0 && (
                    <div className="p-2">
                      <Link to="/users">
                        <span className="text-primary">View More</span>
                      </Link>
                    </div>
                  )}
                </div>

                <div className="col-md-6 mb-4">
                  <div className="table-container mt-4" style={{ flexGrow: 1 }}>
                    <table className="table table-borderless mb-0" style={{ height: '100%' }}>
                      <thead>
                        <tr>
                          <th colSpan="3" className="text-center font-weight-bold">Today Subscribed Users</th>
                        </tr>
                        <tr>
                          <th>S.No</th>
                          <th>Email</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerSummary?.todayRegisteredUsers?.length > 0 ? (
                          customerSummary?.todaySubscriberUsers ?? []).slice(0, 5).map((user, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{user.email}</td>
                              <td>{user.createdAt}</td>
                            </tr>
                          ))
                          : (
                            <tr>
                              <td colSpan="3" className="text-center theme-text-color">No data available</td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                  {customerSummary?.todaySubscriberUsers?.length > 0 && (
                    <div className="p-2">
                      <Link to="/users">
                        <span className="text-primary">View More</span>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div> */}


                {/* <div className="container py-4">
              <h4 className="mb-4 fw-bold">Sales Summary</h4>
              <div className="row g-4">
                {salesSummaryData.map((section, index) => (
                  <div className="col-12" key={index}>
                    <SalesTable title={section.title} data={section.data} />
                  </div>
                ))}
              </div>
            </div> */}

                {/* < div className="py-2" >
              <div className="accordion" id="salesSummaryAccordionWrapper">
                <div className="accordion-item border rounded-3 shadow-sm">
                  <h2 className="accordion-header" id="salesSummaryHeading">
                    <button
                      className={`accordion-button px-3 py-2 small fw-semibold d-flex justify-content-between align-items-center ${isSalesOpen ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => setIsSalesOpen(!isSalesOpen)}
                      style={{ backgroundColor: "#f8f9fa", transition: "background-color 0.9s ease" }}
                    >
                      Sales Summary
                      <i className={`ms-auto bi ${isSalesOpen ? "bi-chevron-up" : "bi-chevron-down"} transition-transform`} />
                    </button>
                  </h2>
                  <div
                    id="salesSummaryCollapse"
                    className={`accordion-collapse collapse ${isSalesOpen ? "show" : ""}`}
                    style={{ transition: "all 0.9s ease" }}
                  >
                    <div className="accordion-body">
                      <div className="row g-4">
                        {salesSummaryData.map((section, index) => (
                          <div className="col-12" key={index}>
                            <SalesTable title={section.title} data={section.data} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="py-2">
              <div className="accordion" id="monthlySummaryAccordion">
                <div className="accordion-item border rounded-3 shadow-sm">
                  <h2 className="accordion-header" id="monthlySummaryHeading">

                    <button
                      className={`accordion-button px-3 py-2 small fw-semibold d-flex justify-content-between align-items-center ${isMonthlyOpen ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => setIsMonthlyOpen(!isMonthlyOpen)}
                      style={{ backgroundColor: "#f8f9fa", transition: "background-color 0.9s ease" }}
                    >
                      MONTHLY SUMMARY (After all deductions)
                      <i className={`ms-auto bi ${isMonthlyOpen ? "bi-chevron-up" : "bi-chevron-down"} transition-transform`}></i>
                    </button>
                  </h2>
                  <div
                    id="monthlySummaryCollapse"
                    className={`accordion-collapse collapse ${isMonthlyOpen ? "show" : ""}`}
                    style={{ transition: "all 0.9s ease" }}
                  >
                    <div className="accordion-body">
                      <div className="row g-4">
                        {monthlySummaryData.map((section, index) => (
                          <div className="col-12" key={index}>
                            <MonthlySummaryTable title={section.title} data={section.data} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
              </div>
              </div>
            </section>
            <HelpdeskFloatingButton />
          </>
        </div>}


        {role === '4' && <Dashboard_Partner />}


        <Modal show={showSkipModal} onHide={() => setShowSkipModal(false)} centered className="playout-reminder-modal">
          <Modal.Header closeButton className="border-0 pb-0 shadow-none">
            <Modal.Title className="fw-bold">Don't Forget!</Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-2">
            <div className="text-center py-3">
              <div className="reminder-icon-bg mb-3 d-flex align-items-center justify-content-center mx-auto" style={{ width: '80px', height: '80px', background: 'rgba(13, 110, 253, 0.1)', borderRadius: '50%' }}>
                <FaTv size={40} className="text-primary" />
              </div>
              <p className="theme-text-color">
                You can always explore the <strong>Playout Guide</strong> later by clicking the "Playout Guide" button on the TV Playouts page.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            <button className="btn btn-primary w-100 rounded-pill py-2" onClick={() => setShowSkipModal(false)}>
              Got it, thanks!
            </button>
          </Modal.Footer>
        </Modal>

        {/* Usage Details Modal */}
        <Modal 
          show={showUsageModal} 
          onHide={() => setShowUsageModal(false)} 
          centered 
          size="xl" 
          dialogClassName="modal-85w"
          className="usage-details-modal"
        >


          <Modal.Header closeButton className="border-bottom-0 pb-0 px-4 pt-4">
            <Modal.Title className="fw-bold d-flex align-items-center gap-3 fs-3">
              <div className="bg-primary-subtle p-2 rounded-3 text-primary d-flex">
                <FiDatabase size={24} />
              </div>
              Usage Breakdown & Analytics
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4 p-lg-5">

            <div className="row g-4 justify-content-center">
              {/* Storage Section */}
              <div className="col-md-5">
                <div className="p-4 rounded-4 bg-light border border-white shadow-sm h-100">
                  <h6 className="fw-bold mb-4 text-dark d-flex align-items-center gap-2">
                    <FiServer size={18} className="text-primary" />
                    Storage Detailed
                  </h6>
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Total Storage Limit</span>
                      <span className="fw-bold text-dark">{parseFloat(cdnUsage?.summary?.totalStorageGB || 0).toFixed(2)} GB</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Used (Assets)</span>
                      <span className="fw-bold text-dark">{parseFloat(cdnUsage?.summary?.usedStorageAssetsGB || 0).toFixed(2)} GB</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Stream (Transcoding)</span>
                      <span className="fw-bold text-dark">{parseFloat(cdnUsage?.summary?.streamStorageGB || 0).toFixed(2)} GB</span>
                    </div>
                    <hr className="my-1 border-light" />
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Total Used</span>
                      <span className="fw-bold text-primary">{parseFloat(cdnUsage?.summary?.totalUsedGB || 0).toFixed(2)} GB</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted small">Remaining Space</span>
                      <span className="fw-bold text-success">{parseFloat(cdnUsage?.summary?.remainingStorageGB || 0).toFixed(2)} GB ({(100 - storageUsagePercentage).toFixed(2)}%)</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bandwidth History Chart */}
              <div className="col-md-5">
                <div className="p-4 rounded-4 bg-light border border-white shadow-sm h-100">
                  <h6 className="fw-bold mb-1 text-dark d-flex align-items-center gap-2">
                    <FiZap size={18} className="text-warning" />
                    Bandwidth History
                  </h6>
                  <p className="text-muted small mb-3">Monthly CDN bandwidth — account total (GB)</p>
                  {bandwidthHistory.length > 0 ? (
                    <Suspense fallback={<div className="text-center py-4 text-muted small">Loading chart…</div>}>
                      <Chart options={bwHistoryChartOptions} series={bwHistoryChartSeries} type="area" height={280} />
                    </Suspense>
                  ) : (
                    <div className="text-center py-5 text-muted small">No history records yet</div>
                  )}
                  <div className="mt-3 pt-3 border-top border-light d-flex justify-content-between align-items-center">
                    <span className="text-muted small">This Month Total</span>
                    <span className="fw-bold text-warning">{totalBandwidthGB.toFixed(2)} GB</span>
                  </div>
                </div>
              </div>
            </div>


            {/* Main Visualizations Row */}
            <div className="row g-4 mt-1">
              <div className="col-md-5">
                <div className="p-4 rounded-4 bg-white border border-light shadow-sm h-100">
                  <h6 className="fw-bold mb-4 text-dark small text-uppercase d-flex align-items-center gap-2">
                    <FiDatabase size={16} className="text-primary" />
                    Storage Distribution
                  </h6>
                  <div className="d-flex justify-content-center">
                    <Chart options={storageDonutOptions} series={storageDonutSeries} type="donut" height={320} />
                  </div>
                  <div className="mt-4 d-flex flex-column gap-3 mx-auto" style={{ maxWidth: '400px' }}>
                    {storageDonutLabels.map((label, idx) => (
                      <div key={idx} className="d-flex align-items-center justify-content-between small">
                        <div className="d-flex align-items-center gap-2">
                          <div className="rounded-circle" style={{ width: '12px', height: '12px', backgroundColor: storageDonutOptions.colors[idx] }}></div>
                          <span className="text-muted fw-medium">{label}</span>
                        </div>
                        <span className="fw-bold text-dark">{parseFloat(storageDonutSeries[idx] || 0).toFixed(2)} GB</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-md-7">
                <div className="p-4 rounded-4 bg-white border border-light shadow-sm h-100">
                  <h6 className="fw-bold mb-4 text-dark small text-uppercase d-flex align-items-center gap-2">
                    <FiTrendingUp size={16} className="text-primary" />
                    Usage Trends (6 Months)
                  </h6>
                  <Chart options={trendChartOptions} series={trendChartSeries} type="line" height={420} />


                </div>
              </div>
            </div>

            {/* Detailed Breakdown Tables */}
            <div className="mt-4">
              <div className="row g-4 justify-content-center">
                {/* Assets Zones */}
                <div className="col-md-5">
                  <div className="p-4 rounded-4 bg-white border border-light shadow-sm">
                    <h6 className="fw-bold mb-3 text-dark d-flex align-items-center gap-2">
                      <FiFolder size={18} className="text-primary" />
                      Storage Zones (Assets)
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle border-0 mb-0">
                        <thead>
                          <tr className="text-muted small">
                            <th className="border-0 px-0">Zone Name</th>
                            <th className="border-0 text-end">Used</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cdnUsage?.data?.storageZones?.slice(0, 5).map((zone, idx) => (
                            <tr key={idx}>
                              <td className="border-0 px-0">
                                <div className="fw-semibold text-dark small">{zone.Name}</div>
                                <div className="text-muted" style={{ fontSize: '10px' }}>{zone.Region}</div>
                              </td>
                              <td className="border-0 text-end fw-bold text-dark small">{zone.StorageUsedGB} GB</td>
                            </tr>
                          ))}
                          {!cdnUsage?.data?.storageZones?.length && (
                            <tr><td colSpan="2" className="text-center py-4 text-muted small">No storage zones found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Video Libraries */}
                <div className="col-md-5">
                  <div className="p-4 rounded-4 bg-white border border-light shadow-sm">
                    <h6 className="fw-bold mb-3 text-dark d-flex align-items-center gap-2">
                      <FiVideo size={18} className="text-primary" />
                      Video Libraries (Stream)
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-hover align-middle border-0 mb-0">
                        <thead>
                          <tr className="text-muted small">
                            <th className="border-0 px-0">Library Name</th>
                            <th className="border-0 text-end">Used</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cdnUsage?.data?.streamZones?.slice(0, 5).map((library, idx) => (
                            <tr key={idx}>
                              <td className="border-0 px-0">
                                <div className="fw-semibold text-dark small">{library.Name}</div>
                                <div className="text-muted" style={{ fontSize: '10px' }}>ID: {library.Id}</div>
                              </td>
                              <td className="border-0 text-end fw-bold text-dark small">{library.StorageUsageGB} GB</td>
                            </tr>
                          ))}
                          {!cdnUsage?.data?.streamZones?.length && (
                            <tr><td colSpan="2" className="text-center py-4 text-muted small">No video libraries found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </Modal.Body>
          <Modal.Footer className="border-top-0 bg-light-subtle rounded-bottom-4">
            <div className="me-auto text-muted small">
              <FiClock className="me-1" /> Last synchronized: {new Date().toLocaleTimeString()}
            </div>
            <button className="btn btn-secondary px-4 rounded-pill fw-semibold" onClick={() => setShowUsageModal(false)}>Close Breakdown</button>
          </Modal.Footer>
        </Modal>


      </>
    );
  }


const mapStateToProps = state => ({
    onlyPermission: state.userPermission.onlyPermission,
    userDetails: state.userPermission.userDetails,
    adminSetting: state.siteTheme?.adminSetting,
    storage_settings: state.storageSetting?.data
  });

  export default connect(mapStateToProps)(Dashboard);
